export default __webpack_public_path__ + "static/media/not-visible.ab03f5ce.svg";